import { Flex, Typography } from "@aircall/tractor";
import { useTranslation } from "react-i18next";

import { useCallContextRule } from "@/hooks/useCallContextRule/useCallContextRule";
import { useFeatureFlags } from "@/providers/FeatureFlagProvider/FeatureFlagProvider";
import { SectionCallEvaluation } from "../SectionCallEvaluation";
import { SectionCustomSummary } from "../SectionCustomSummary/SectionCustomSummary";
import { SectionKeyTopics } from "../SectionKeyTopics/SectionKeyTopics";
import { SectionNextActions } from "../SectionNextActions/SectionNextActions";
import { SectionPlaybook } from "../SectionPlaybook/SectionPlaybook";
import { SectionSentiment } from "../SectionSentiment";
import { SectionTalkRatio } from "../SectionTalkRatio";

function InsightsSection() {
  const {
    isTalkRatioDisplayed,
    shouldDisplaySentiments,
    shouldDisplayEvaluation,
  } = useCallContextRule();
  const { enableCustomInsights } = useFeatureFlags();

  return (
    <Flex gap="m" flexDirection="column">
      {enableCustomInsights && <SectionCustomSummary />}
      <SectionPlaybook />
      <SectionKeyTopics />
      <SectionNextActions />
      {shouldDisplayEvaluation && <SectionCallEvaluation />}
      {shouldDisplaySentiments && <SectionSentiment />}
      {isTalkRatioDisplayed && <SectionTalkRatio />}
    </Flex>
  );
}

export function SectionCallContext() {
  const { t } = useTranslation();
  const { shouldDisplayInsights } = useCallContextRule();

  if (!shouldDisplayInsights) {
    return (
      <Typography
        variant="bodyRegularS"
        color="text-disabled"
        data-test="call-context-section"
      >
        {t("call_context.no_insights")}
      </Typography>
    );
  }

  return (
    <Flex gap="m" flexDirection="column" data-test="call-context-section">
      <InsightsSection />
    </Flex>
  );
}
